import { ActivityListTypeEnum } from 'src/models/genericActivityList';

export const completeListExportViewFor = (activityListType: ActivityListTypeEnum): string => {
	switch (activityListType) {
		case ActivityListTypeEnum.MINE:
			return 'mine';
		case ActivityListTypeEnum.OPEN:
			return 'open';
		default:
			return 'all';
	}
};
